<div class="dashboard">
	<bb-page-header [icon]="'home'" [title]="publicationLabel"></bb-page-header>

	<div class="body-column tab-container">
		<!-- left side: media or ads dashboard -->
		<ng-container>
			<dashboard-media *ngIf="hasMediaContext"></dashboard-media>
			<dashboard-ads *ngIf="!hasMediaContext && hasAdsContext"></dashboard-ads>
			<div class="padding" *ngIf="!hasMediaContext && !hasAdsContext">
				<div class="message warning">
					{{ 'NO_OVP_PERMISSIONS' | translate }}
				</div>
				<div class="button" (click)="authenticationService.logout().subscribe();">
					{{ 'SIGN_OUT' | translate }}
				</div>
			</div>
		</ng-container>

		<!-- right side: news and release notes -->
		<div class="dashboard-container news" *ngIf="hasMediaContext || hasAdsContext">
			<h2>{{ 'LATEST_NEWS_FROM_BLUE_BILLYWIG' | translate }}</h2>
			<ng-container *ngFor="let item of newsItems.slice(0, 5); let i = index">
				<div class="line-dashboard">
					<a target="_blank" [href]="item.link" [innerHTML]="item.title.rendered" class="bold"></a>
					<div [innerHTML]="item.date | bbDate: 'date':'long'" class="date"></div>
				</div>
				<hr />
			</ng-container>
			<a class="button" target="_blank" href="https://www.bluebillywig.com/blue-billywig-updates/"><i
					class="fa fa-external-link"></i>{{ 'MORE_NEWS' | translate }} </a>

			<h2>{{ 'LATEST_RELEASES' | translate }} 
			</h2>
			<ng-container *ngFor="let item of releaseItems; let i = index">
				<ng-container *ngIf="i < maxReleases">
					<div class="line-dashboard">
						<a target="_blank" [innerHTML]="('OVP_VERSION' | translate) + item.version" [ngClass]="{'bold': latestRelease.getTime() === item.date.getTime()}" class="title" [href]="item.permalink"></a>
						<span class="new" *ngIf="latestRelease.getTime() === item.date.getTime()">{{ 'NEW' | translate }}</span>
						<div [innerHTML]="item.date | bbDate: 'date':'long'" class="date"></div>
					</div>
					<hr />
				</ng-container>
			</ng-container>
			<div>
				<a class="button" target="_blank" href="https://support.bluebillywig.com/release-notes/">
					<i class="fa fa-external-link"></i> {{ 'ALL_RELEASES' | translate }}
				</a>
			</div>

		</div>
	</div>
</div>
